import { render, staticRenderFns } from "./KPop.vue?vue&type=template&id=306c8d0a&scoped=true&"
import script from "./KPop.vue?vue&type=script&lang=js&"
export * from "./KPop.vue?vue&type=script&lang=js&"
import style0 from "./KPop.vue?vue&type=style&index=0&id=306c8d0a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "306c8d0a",
  null
  
)

export default component.exports